import { Node, mergeAttributes } from '@tiptap/core';

const PdfExtension = Node.create({
  name: 'pdf', // unique name for the Node
  group: 'block', // belongs to the 'block' group of extensions
  selectable: true, // so we can select the video
  draggable: false, // so we can drag the video
  atom: false, // is a single unit

  addAttributes() {
    return {
      ...this?.parent?.(),
      src: {
        default: null,
        parseHTML: (element) => element.src,
      },
      width: {
        default: 800,
        parseHTML: (element) => element.getAttribute('width') || 800,
      },
      height: {
        default: null,
        parseHTML: (element) => element.getAttribute('height') || null,
      },
      alt: {
        default: null,
      },
    };
  },

  parseHTML() {
    return [{ tag: 'iframe' }];
  },

  addNodeView() {
    return ({ node }) => {
      const { width, height } = node.attrs;
      const iframe = document.createElement('iframe');
      const iframeHeight = height || (width * 3) / 4;
      Object.assign(iframe, { ...node.attrs, height: iframeHeight });

      return {
        dom: iframe,
      };
    };
  },

  renderHTML({ HTMLAttributes }) {
    const { height, width } = HTMLAttributes;
    const iframeHeight = height || (width * 3) / 4;

    return ['iframe', mergeAttributes({ ...HTMLAttributes, height: iframeHeight })];
  },
});

export default PdfExtension;
